<script setup>
import Checkbox from "primevue/checkbox";
import {VueSignaturePad} from "vue-signature-pad";
import Button from "primevue/button";
import {ref} from "vue";

const props = defineProps([
    'customer',
    'form',
    'v$',
    'isEdit',
    'hasSignature'
]);

const signaturePad = ref(null)
const isShowSignaturePad = ref((! props.isEdit) || (! props.form.signature_img))
const onBeginSignaturePad = () => {
    if (props.form.has_signature !== true) {
        props.form.has_signature = true

        props.v$.form.signature_key.$touch()
    }
}

const clearSignature = () => {
    signaturePad.value.clearSignature()
}

const changeSignature = () => {
    isShowSignaturePad.value = true
}

const getSignaturePad = () => {
    return signaturePad.value;
}

defineExpose({
    getSignaturePad,
})
</script>

<template>
    <div>
        <div class="flex gap-4">
            <div class="pt-[2px]">
                <Checkbox
                    :invalid="v$.form.is_agree_signature.$error"
                    v-model="form.is_agree_signature"
                    :binary="true"
                    @change="v$.form.is_agree_signature.$touch"></Checkbox>
            </div>

            <div>
                Mit meiner Unterschrift bestätige ich alle Punkte der Einverständniserklärung und des Vertrages gelesen zu haben und bestätige diese hiermit.
            </div>
        </div>

        <div v-if="v$.form.is_agree_signature.$error" class="text-sm text-[#dc2626]">
            {{ v$.form.is_agree_signature.$errors[0].$message }}
        </div>
    </div>

    <div class="my-2">
        <div class="grid grid-cols-2 gap-5">
            <div class="h-full">
                <div class="flex flex-col gap-0 h-full">
                    <h3 class="font-bold">Unterschrift Kundin/Kunde:</h3>
                    <div class="flex-1">
                        <VueSignaturePad v-if="isShowSignaturePad"
                                         class="w-full border border-[#94a3b8]"
                                         :class="{
                                            'border-[#f87171]': v$.form.signature_key.$error,
                                         }"
                                         ref="signaturePad"
                                         height="auto"
                                         :options="{
                                                onBegin: onBeginSignaturePad
                                         }" />
                        <div  v-else class="w-full border border-[#94a3b8]">
                            <img :src="form.signature_img" class="w-full h-auto" />
                        </div>

                        <div v-if="v$.form.signature_key.$error" class="text-sm text-[#dc2626]">
                            {{ v$.form.signature_key.$errors[0].$message }}
                        </div>
                    </div>
                </div>
            </div>

            <div class="h-full">
                <div class="flex flex-col gap-0 h-full">
                    <h3 class="font-bold">Unterschrift Frau Petra Schneider</h3>
                    <div class="flex-1 border border-[#94a3b8]">
                        <div class="flex w-full h-full justify-center items-center p-5">
                            <img class="max-w-100 h-auto" :src="asset('img/signature-consent.png')" />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="grid grid-cols-2 gap-5 mt-2">
            <div class="flex justify-end">
                <Button
                    v-if="isShowSignaturePad"
                    label="Klar"
                    size="small"
                    severity="secondary"
                    class="text-sm"
                    @click="clearSignature"
                />
                <Button v-else
                        size="small"
                        severity="secondary"
                        class="text-sm"
                        @click="changeSignature">ändern</Button>
            </div>
        </div>
    </div>

    <div class="grid grid-cols-2 gap-5">
        <div class="h-full">
            <h4 class="font-bold my-5">{{ customer.first_name }} {{ customer.last_name }}</h4>

            <div class="flex items-center gap-4">
                <div class="font-bold">Winterthur, den</div>

                <div>{{ form.date }}</div>
            </div>
        </div>

        <div class="h-full">
            <h4 class="font-bold my-5">Sani Medical AG</h4>

            <div class="flex items-center gap-4">
                <div class="font-bold">Winterthur, den</div>

                <div>{{ form.date }}</div>
            </div>
        </div>
    </div>
</template>
